import i18next from 'i18next'
// import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import nl from './locales/nl'
import nlStichting from './locales/nl-stichting'

i18next
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: 'nl',
    fallbackLng: 'nl',
    load: 'languageOnly',
    // debug: true,
    returnObjects: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
    },
  })

// add all translations
const locales = { nl }
Object.entries(locales).forEach(([language, value]) =>
  Object.entries(value).forEach(([namespace, translations]) =>
    i18next.addResourceBundle(language, namespace, translations),
  ),
)

if (__BUILDFOR__ === 'stichting') {
  // add stichting translations (overwrite existing)
  Object.entries(nlStichting).forEach(([namespace, translations]) =>
    i18next.addResourceBundle('nl', namespace, translations, true, true),
  )
}

export default i18next
